<template>
    <el-footer class="footer" style="height: 100%;">
      <div class="footer-container">
        <!-- 左侧 LOGO -->
        <div class="footer-logo">
          <img src="@/assets/header/logo.png" alt="Logo">
        </div>
  
        <!-- 右侧信息 -->
        <div class="footer-info">
          <p><i class="fas fa-map-marker-alt"></i> Möllegränden 10, 25223 Helsingborg</p>
          <p><i class="fas fa-phone"></i> 0046-070428 17 56</p>
          <p><i class="fas fa-envelope"></i> modongmichael@gmail.com</p>
          
          <!-- 社交媒体图标 -->
          <div class="footer-socials">
            <a href="#"><i class="fab fa-twitter"></i></a>
            <a href="#"><i class="fab fa-facebook"></i></a>
            <a href="#"><i class="fab fa-google"></i></a>
          </div>
        </div>
      </div>
  
      <!-- 底部版权信息 -->
      <div class="footer-bottom">
        Copyright © All Rights Reserved
      </div>
    </el-footer>
  </template>
  
  <script>
  export default {
    name: "FooterP"
  };
  </script>
  
  <style scoped>
  .footer {
    width: 100%;
    background-color: #1e3553;
    color: white;
    padding: 40px 5%; /* 调整padding */
    text-align: center;
  }
  .el-footer {
    /* padding: 0; */
  }
  .footer-container {
    width: 100%;
    min-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start; /* 顶部对齐 */
  }
  
  .footer-logo img {
    width: 120px;
    height: auto;
    margin-right: 30px; /* 减少margin */
  }
  
  .footer-info {
    text-align: left;
    flex: 1; /* 允许扩展 */
    max-width: 400px; /* 限制最大宽度 */
  }
  
  .footer-info p {
    margin: 8px 0; /* 调整margin */
    font-size: 14px;
    display: flex;
    align-items: center;
  }
  
  .footer-info i {
    margin-right: 8px;
    color: #4caf50; /* 绿色图标 */
  }
  
  /* 社交媒体图标 */
  .footer-socials {
    margin-top: 10px;
  }
  
  .footer-socials a {
    color: white;
    font-size: 18px;
    margin: 0 8px;
    transition: color 0.3s ease;
  }
  
  .footer-socials a:hover {
    color: #4caf50; /* 绿色 */
  }
  
  /* 版权信息 */
  .footer-bottom {
    margin-top: 20px;
    font-size: 12px;
    opacity: 0.8;
  }
  
  /* 响应式 */
  @media (max-width: 768px) {
    .footer {
      padding: 30px 20px;
    }
    
    .footer-container {
      flex-direction: column;
      align-items: center;
    }
    
    .footer-logo img {
      margin: 0 0 20px 0;
      width: 100px; /* 缩小logo */
    }
    
    .footer-info {
      text-align: center;
      max-width: none; /* 移除最大宽度限制 */
    }
    
    .footer-info p {
      justify-content: center; /* 文字居中 */
    }
    
    .footer-socials {
      margin-top: 15px;
    }
  }
  
  @media (max-width: 768px) {
    .footer-info p {
      font-size: 13px; /* 更小的字体 */
    }
    
    .footer-socials a {
      font-size: 16px; /* 更小的图标 */
    }
    
    .footer-bottom {
      font-size: 11px; /* 更小的版权文字 */
    }
  }
  </style>
